<template>
  <div class="salon-reservation">
    <div class="salon-reservation-title">
      <h4>{{ currentRoomInfor.room_name }}</h4>
      <span>{{ currentRoomInfor.need_audit }}</span>
      {{ currentRoomInfor.reserved_time || currentRoomInfor.audit_info }}
    </div>
    <div class="salon-reservation-des">
      <p>
        <van-icon name="setting-o" /> {{ currentRoomInfor.room_desc }}
      </p>
      <p>
        <van-icon name="contact" /> {{ currentRoomInfor.lay_table_str }}
      </p>
    </div>
    <div class="salon-reservation-time">
      <div
        class="salon-reservation-time-item"
        v-for="item in timeList"
        :key="item.time"
      >
        <div class="salon-reservation-time-item-left">
          <van-checkbox
            v-model="item.checked"
            :disabled="item.status === 2 || item.status === 1"
          >
            {{ item.time }}
          </van-checkbox>
        </div>
        <div
          class="salon-reservation-time-item-right"
          v-if="item.status === 2"
        >
          已过期
        </div>
        <div
          class="salon-reservation-time-item-right"
          v-if="item.status === 1"
        >
          <span v-if="item.source === 'dingding'">
            会议已预定
          </span>
          <span v-else>
            沙龙已预定({{ item.user_name }})
          </span>

        </div>
      </div>

    </div>
    <div
      class="salon-reservation-bottom"
      @click="subscribe"
    >
      立即预定
    </div>
  </div>
</template>

<script>
import getUserInfo from "@/models/userInfo";
import meetingService from "@/apis/meeting/index.js";
import { Toast } from "vant";
import salonMixins from "./mixins/index.js";

export default {
  mixins: [salonMixins],
  data() {
    return {
      checked: false,
      timeList: [],
      roomId: 1,
      currentRoomInfor: {},
    };
  },
  async created() {
    this.roomId = this.$route.query.roomId;
    const userInfo = await getUserInfo();
    this.currentUserInfo = userInfo;
    this.currentRoomInfor = await this.getRoomInfoById(this.roomId);
    this.getCalendar();
  },
  methods: {
    getCalendar() {
      const query = this.$route.query;
      const date = query.date;
      const params = {
        room_id: query.roomId,
        ding_user_id: this.currentUserInfo.ding_user_id,
        start_date: date,
        end_date: date,
      };
      meetingService.getCalendar(params).then((res) => {
        const date = res[0];
        this.timeList = date.details;

        console.log(date);
      });
    },
    subscribe() {
      const { timeList } = this;
      const selectList = timeList.filter((item) => item.checked);
      const dataLength = selectList.length;
      let errMsg = "";
      if (dataLength === 0) {
        errMsg = "请选择要预约的时间段";
      } else if (
        dataLength > 1 &&
        selectList.some((item, index) => {
          if (index === dataLength - 1) return false;

          const nextDate = selectList[index + 1];
          return item.time.split("~")[1] !== nextDate.time.split("~")[0];
        })
      ) {
        errMsg = "清选择连续时间段";
      }
      if (errMsg) {
        Toast(errMsg);
        return;
      }
      this.$router.push({
        name: "SalonAdd",
        query: {
          ...this.$route.query,
          timeList: encodeURIComponent(
            selectList.map((item) => item.time).join(",")
          ),
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.salon-reservation {
  padding: 20px 0;
  background-color: #fff;
}
.salon-reservation-title {
  display: flex;
  align-items: center;
  font-size: 12px;
  padding: 0 15px;
  h4 {
    font-size: 18px;
    margin: 0;
  }
  span {
    display: block;
    padding: 0px 5px;
    background-color: #b4b4ff;
    color: #5d00ff;
    margin: 0 5px;
    flex-shrink: 0;
  }
}
.salon-reservation-des {
  padding: 0 15px;

  p {
    margin: 5px 0;
  }
}
.salon-reservation-time-item {
  display: flex;
  justify-content: space-between;
  padding: 10px 15px;
  border-bottom: 1px solid #999;
  //   background-color: #fff;
  .salon-reservation-time-item-left {
    flex: 1;
  }
  .salon-reservation-time-item-right {
    color: #999;
    span {
      //   color: #5d00ff;
    }
  }
}
.salon-reservation-bottom {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 20px;

  margin-top: 20px;
  color: #fff;
  border-radius: 5px;
  height: 40px;
  background-color: #367df3;
}
</style>